import {useEffect, useRef} from 'react';
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from 'react-router-dom';


const LogOutComponent = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const didLogout = useRef(false);

    useEffect(()=>{
        // Run once — logout identity must not retrigger this
        if (didLogout.current) return;
        didLogout.current = true;

        const runLogout = async () => {
            await logout();
            navigate('/admin', { replace: true });
        };
        runLogout();
    }, [logout, navigate])
    
    return null;
};

export default LogOutComponent;
